import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { BrotherAttributionModalType } from "../brother-attribution-models/brother-attribution-modal-type";
import { FamilyModel } from "../brother-attribution-models/family-model";
@Component({
  selector: "brother-attribution-page-main-modal-container",
  templateUrl: "./brother-attribution-page-main-modal-container.component.html",
  styleUrls: ["./brother-attribution-page-main-modal-container.component.scss"],
})
export class BrotherAttributionPageMainModalContainerComponent
  implements OnInit
{
  public static readonly modalOptions: NgbModalOptions = {
    backdropClass: "create-event-backdropClass",
    backdrop: true,
    windowClass: "brother-attribution-window-class",
  };
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  public family: FamilyModel;
  public readonly BrotherAttributionModalType = BrotherAttributionModalType;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef
  ) {}

  public _brotherAttributionModalType: BrotherAttributionModalType;

  @Input("brotherAttributionModalType")
  public set brotherAttributionModalType(value: BrotherAttributionModalType) {
    if (value && value !== this._brotherAttributionModalType) {
      this._brotherAttributionModalType = value;
    }
  }

  @Input("familyToEdit")
  public set familyToEdit(value: FamilyModel) {
    if (value && value !== this.family) {
      this.family = value;
    }
  }

  public ngOnInit(): void {
    this._brotherAttributionModalType =
      this._brotherAttributionModalType ||
      BrotherAttributionModalType.createNewFamilyConnection;
  }

  public modalClose(result: string) {
    this.activeModal.close(result);
  }

  public modalActionsHandler($event: any) {
    if ($event === "close") {
      this.modalClose(null);
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brother-attribution-page-main-modal-container/brother-attribution-page-main-modal-container.component.ts